import { SuspenseQueryWith } from '@/utils/types'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useAccount } from '@/domain/hooks/useAccount'
import { L1Balances, l1BalancesQueryOptions } from './query'

export type UseL1BalancesResult = SuspenseQueryWith<{
  balances: L1Balances
}>

export function useL1Balances({ refetchInterval }: { refetchInterval?: number } = {}): UseL1BalancesResult {
  const account = useAccount()

  const response = useSuspenseQuery({
    ...l1BalancesQueryOptions({
      account,
    }),
    refetchInterval: refetchInterval ?? undefined,
  })

  return {
    ...response,
    balances: response.data,
  }
}
